import { computed } from 'vue-demi';

function useProxyModelValue(modelValue, emit) {
  let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const {
    defaultValue
  } = options;
  if (defaultValue) {
    return computed({
      get: () => {
        var _a;
        return (_a = modelValue.value) !== null && _a !== void 0 ? _a : defaultValue.value;
      },
      set: value => {
        emit('update:modelValue', value);
      }
    });
  }
  return computed({
    get: () => {
      return modelValue.value;
    },
    set: value => {
      emit('update:modelValue', value);
    }
  });
}

export { useProxyModelValue as u };
